// extracted by mini-css-extract-plugin
export default {"form":"AuthForm_form__kV4hH","button":"AuthForm_button__B5dfz"};